import { IIconProps } from "~/types";
const CheckIcon = (props:IIconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m6.75 9 1.5 1.5 3-3m4.5 1.5a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0"
      stroke="#313036"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CheckIcon;
